import type { NavItemType } from "@wbly/data-storefront";
import { map, atom } from "nanostores";

export type ItemLevelsParams = {
  level: 1 | 2 | 3;
  type?: "mobile";
  items: NavItemType[] | NavItemType;
};

export type StoreType = {
  navItems: NavItemType[];
  l2: number | null;
  mobile_l1: NavItemType[];
  mobile_l2: NavItemType[];
  mobile_l3: NavItemType[];
  panelTitle: string | null;
  isDesktop: boolean | null;
  currentMobileIndex: number;
  slideLevel?: number;
};

export const $nav = map({
  navItems: [],
  l2: 0,
  mobile_l1: [],
  mobile_l2: [],
  mobile_l3: [],
  panelTitle: null,
  nextLevel: null,
  previousLevel: null,
  isDesktop: null,
  currentMobileIndex: 0,
  slideLevel: 0,
} as StoreType);

export const $submenuIndex = atom(null);

export const setDesktopLevel = (level: number, current: number) => {
  $nav.set({ ...$nav.get(), [`l${level}`]: current });
};

export const setNavItems = (navItems) => {
  $nav.set({ ...$nav.get(), navItems });
};

export const getNavItems = () => {
  return $nav.get().navItems;
};

export const setSubmenuIndex = (index: number) => {
  $submenuIndex.set(index);
};

export const setPanelTitle = (newPanelTitle: string) => {
  $nav.set({ ...$nav.get(), panelTitle: newPanelTitle });
};

export const setItemLevel = ({ level, items, type }: ItemLevelsParams) => {
  const currentNav = $nav.get();

  let key = "";
  switch (type) {
    case "mobile":
      key = `mobile_l${level}`;
      break;
    default:
      key = `l${level}`;
  }

  $nav.set({
    ...currentNav,
    [key]: items,
  });
};

export const setDesktop = (isDesktop: boolean) => {
  $nav.set({ ...$nav.get(), isDesktop });
};

export const setMobileIndex = (index: number) => {
  $nav.set({ ...$nav.get(), currentMobileIndex: index });
};

export const setSlideLevel = (level: number) => {
  $nav.set({ ...$nav.get(), slideLevel: level });
};

export const resetNav = () => {
  $nav.set({
    navItems: $nav.get().navItems,
    mobile_l1: $nav.get().mobile_l1,
    mobile_l2: [],
    mobile_l3: [],
    isDesktop: $nav.get().isDesktop,
    panelTitle: null,
    currentMobileIndex: 0,
    slideLevel: 0,
    l2: 0,
  });
};
